module.exports = __webpack_public_path__ + "media/images/bg/hero-e45ac813d46c5d8830796f9655b67073.jpg";